import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const Footer = styled(Flex).attrs({
  shrink: '0',
  padding: '15px',
  column: true,
})`
  width: 100%;
  background-color: #f9f9f9;
  border-top: 2px solid rgba(40, 45, 48, 0.1);
`;

export const Actions = styled(Flex).attrs({
  column: true,
})`
  padding: 2px 0;
  background: #fff;
  box-sizing: border-box;
  min-width: 120px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
`;

export const Action = styled(Flex).attrs({
  align: 'center',
  spacing: 8,
  padding: '5px 10px',
})`
  width: 100%;
  opacity: 0.8;
  font-size: 14px;
  cursor: pointer;
  position: relative;

  input {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
  }

  &:hover {
    opacity: 1;
    background: rgba(193, 193, 193, 0.3);
  }
`;

export const Video = styled(Flex).attrs({
  align: 'center',
  spacing: 10,
})`
  color: #fff;
  font-size: 15px;
  padding: 8px 12px;
  background: #b1b1b1;
  border-radius: 6px;
  position: absolute;
  top: -60px;
  left: 0px;
`;

export const Preview = styled.span`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
`;

export const Remove = styled.span`
  position: absolute;
  top: -5px;
  right: -15px;
  width: 16px;
  height: 16px;
  cursor: pointer;
`;
